import './assets/main.css'
import "vue-toastification/dist/index.css";
import '../node_modules/sweetalert2/dist/sweetalert2.css';

// font awesome version: 5.15.4
import '../node_modules/@fortawesome/fontawesome-free/css/all.min.css';

import App from "@/App.vue";
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import Toast from "vue-toastification";
import router from './router/Router'

const app = createApp(App);

app.use(createPinia());
app.use(Toast);
app.use(router);

app.mount('#app');
